import { SettingsFooter, Button } from "dyl-components";
import { Icon, Popup, List } from 'semantic-ui-react';
import { Link, useNavigate } from 'react-router-dom';
import React from "react";
import './index.scss'

export const DataMappingFooter = ({
    parseId,
    post,
    isMinimumFields,
    isReadingEmail,
    createEmailMapping,
    createPostMapping,
    isNextStepEnabled,
    width = "100%",
    currentStep,
    STEPS,
    goToPreviousStep
}) => {
    const navigate = useNavigate();
    const nextClick = () => {
        if (currentStep === 2) {
            navigate('/settings/data-integration-logs')
        } else {
            post ? createPostMapping() : createEmailMapping();
        }
    }

    const link = `${post ? 'post' : 'email'}-parsing-template/${parseId}`;
    const error = <Popup
                        content={
                            <div>
                                <div className="MinimumErrors"><u>Errors</u></div>
                                    <List as="ol" className="MinimumErrors">
                                        {isMinimumFields.validFields.map(field=>{
                                            if(!field.isValid){
                                                return (
                                                    <List.Item as='li'>{field.text}</List.Item>
                                                )
                                            }
                                            return ''
                                        })}
                                    </List>
                            </div>
                        }
                        wide='very'
                        position='top center'
                        trigger={
                            <Icon size='large' className='fa-solid fa-triangle-exclamation WarningRed' />
                        }
                        open
                    />
    return (
        <SettingsFooter
            style={{ width: width }}
            className={`Webform__menu`}
            leftOptions={[
                ((!isMinimumFields.isValid && !isReadingEmail) && error),
                currentStep < STEPS.length - 1 && <Button primary basic onClick={()=>goToPreviousStep(`/settings/${link}`)}>Back</Button>
            ]}
            rightOptions={[
                currentStep < STEPS.length - 1 && <Button primary as={Link} to='/settings/data-integration-logs' status={'cancel'} basic>Cancel</Button>,
                <Button onClick={nextClick} disabled={(!isNextStepEnabled())} color={(!isNextStepEnabled()) ? 'black' : 'primary'}>
                    {currentStep < STEPS.length - 1 ? 'Confirm Mapping' : 'Done'}
                </Button>,
            ]}
        />
    );
};
